import cx from 'classnames'

import { Info, MissingData, Tick } from 'common/icons'
export type Type = 'success' | 'error' | 'info' | 'warn'

const iconProps = {
  className: 'mr-2 w-4',
  isDefaultColor: false,
}

type Props = {
  type: Type
  className?: string
  showIcon?: boolean
}

const Alert: React.FC<Props> = ({
  type,
  showIcon,
  children,
  className = '',
}) => {
  let typeClassName: string = ''
  let icon: React.ReactNode = null

  switch (type) {
    case 'success':
      typeClassName = 'bg-green-50 text-green-700 border-green-400'
      icon = <Tick {...iconProps} />
      break
    case 'error':
      typeClassName = 'bg-red-50 text-red-600 border-red-400'
      icon = <Info {...iconProps} />
      break
    case 'info':
      typeClassName = 'bg-lightBlue-50 text-lightBlue-600 border-lightBlue-400'
      icon = <Info {...iconProps} />
      break
    case 'warn':
      typeClassName = 'bg-amber-50 text-amber-700 border-amber-400'
      icon = <MissingData {...iconProps} />
      break

    default:
      break
  }

  return (
    <div
      className={cx('p-4 rounded border font-medium', typeClassName, className)}
    >
      {showIcon && icon}
      {children}
    </div>
  )
}

export default Alert
